import React from 'react';
import styled from 'styled-components';
import runningPhoto from '../../assets/zetatrack/running-sensor.png';
import weightPhoto from '../../assets/zetatrack/weight-sensor.png';

const Guide = styled.section`
    margin:0 24px 24px; padding:18px; border:1px solid #f1c3c6; border-radius:8px; background:#fffafb;
    h3 {margin:0 0 14px; color:#d5222b; font-size:15px;}
    h4 {margin:0 0 8px; font-size:14px;}
    p, ol {font-size:13px; color:#555;}
    .instructions {display:grid; grid-template-columns:minmax(240px, 40%) 1fr; gap:20px;}
    img {width:100%; height:auto; object-fit:contain; border-radius:6px;}
    .steps {display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:28px; list-style:none; padding:0;}
    .steps li {position:relative; background:#fff; padding:14px; border:1px solid #e0e4ea; border-radius:6px;}
    .steps li:not(:last-child)::after {content:'→'; position:absolute; right:-23px; top:40%; color:#1a73e9; font-size:20px;}
    .steps b {display:block; margin-bottom:6px; color:#333;}
    .cost {color:#c5222b; display:block; margin-top:6px;}
    @media(max-width:1100px) {
        .instructions {grid-template-columns:1fr;}
        .steps {grid-template-columns:1fr;}
        .steps li:not(:last-child)::after {content:'↓'; top:auto; right:50%; bottom:-27px;}
    }
`;
export default function SensorIssueGuide({type, devices}) {
    const running = type === 'running';
    const affected = devices && devices.filter(device => device.sensorStatus === 'abnormal');
    if (affected && !affected.length) return null;
    return <Guide aria-label={running ? '러닝 센서 이상 안내' : '웨이트 센서 이상 안내'}>
        <h3>{running ? '러닝' : '웨이트'} 센서 미감지 안내</h3>
        {affected && <p><strong>확인할 기기: {affected.map(device => `${running ? '러닝' : '웨이트'} ${device.number}번`).join(', ')}</strong></p>}
        <div className="instructions">
            <img src={running ? runningPhoto : weightPhoto} alt={running
                ? '러닝머신 하단 뒤 센서와 머신 밖으로 나오는 전원 케이블 연결 예시'
                : '웨이트 기구 상단 센서의 전원 포트 연결 예시'} />
            <div>
                <h4>{running ? '러닝머신 하단 뒤 센서의 전원 연결을 확인하세요.' : '기구 상단 센서의 전원 연결을 확인하세요.'}</h4>
                <p>{running ? '러닝 센서는 외부 전원에 연결해 사용합니다. 배터리는 사용하지 않습니다.'
                    : '웨이트 센서는 전원 케이블 또는 보조배터리로 동작합니다.'}</p>
                <ol>
                    <li>센서의 전원 포트에 케이블이 끝까지 꽂혀 있는지 확인합니다.</li>
                    <li>{running ? '머신 밖으로 나온 케이블의 외부 전원 연결을 확인합니다.'
                        : '연결한 전원 또는 보조배터리의 충전 상태와 케이블 연결을 확인합니다.'}</li>
                    <li>연결 후 센서 상태가 정상으로 바뀌는지 확인합니다.</li>
                </ol>
            </div>
        </div>
        <h4>AS 진행 순서</h4>
        <ol className="steps">
            <li><b>1. 먼저 직접 점검</b>사장님이 안내에 따라 전원과 케이블 연결을 먼저 확인합니다.</li>
            <li><b>2. 고장이면 센서 배송</b>점검 후에도 해결되지 않아 고장으로 확인되면 교체 센서를 보내드립니다. 받은 센서는 직접 교체해 주세요.</li>
            <li><b>3. 셀프 교체가 어려우면 기사 지원</b>직접 교체가 어려운 경우 AS 기사가 지원합니다.<span className="cost">출장비 및 수리 비용이 청구될 수 있습니다.</span></li>
        </ol>
    </Guide>;
}
